exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".locationText{font-family:'Lato-Regular', sans-serif;margin-bottom:16px;color:var(--text)}.hoursComponent-hours{margin-bottom:16px}.hoursComponent-locationHoursHeading{font-family:'Lato-Bold', sans-serif;font-size:small;font-weight:bold;margin-bottom:8px;color:var(--text);padding-left:6px}.businessHours{margin-bottom:8px;color:var(--text);padding-left:6px}.regularHours{margin-bottom:8px;color:var(--text)}.holidayHours{font-family:'Lato-Regular';font-style:italic;margin-bottom:8px;color:var(--primary-color);padding-left:6px}\n", ""]);

// exports
